import type { PartSvgProps } from './types'

export default function AkMagDrumSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 140,
  height = 160
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 140 160" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* feed neck */}
      <rect x="48" y="4" width="44" height="36" rx="4"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* feed lips */}
      <rect x="44" y="4" width="52" height="10" rx="2" fill={stroke} />
      {/* drum body */}
      <circle cx="70" cy="105" r="52"
              fill={fill} stroke={stroke} strokeWidth="2" />
      {/* inner ring detail */}
      <circle cx="70" cy="105" r="30"
              fill="none" stroke={stroke} strokeWidth="1" strokeOpacity="0.4" />
      {/* wind knob */}
      <circle cx="118" cy="105" r="8" fill={stroke} />
    </svg>
  )
}
